export default __webpack_public_path__ + "static/media/TreeDots.e5a2fb42.svg";